import React, { useEffect, useState } from "react";
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import "./printCauseListDisposal.css";

const DisposalCauseList = () => {
  const [isLoading, setLoading] = useState(false);
  const [dailyCauseList, setDailyCauseList] = useState([]);
  const [date, setDate] = useState("");


  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  };

  const formatLegalDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const weekday = d.toLocaleDateString("en-US", { weekday: "long" }).toUpperCase();
    const month = d.toLocaleDateString("en-US", { month: "long" }).toUpperCase();
    const year = d.getFullYear();
    const day = getOrdinal(d.getDate());

    return `${weekday} THE ${day} DAY OF ${month}, ${year}`;
  };

  const dateSuffix = (day) => {
    if (day == 1 || day == 21 || day == 31) {
      return day + "" + "st";
    } else if (day == 2 || day == 22) {
      return day + "" + "nd";
    } else if (day == 3 || day == 23) {
      return day + "" + "rd";
    } else {
      return day + "" + "th";
    }
  };

  const formattedDate =
    date &&
    (
      new Date(date).toLocaleDateString("en-us", { weekday: "long" }) +
      ", " +
      dateSuffix(
        new Date(date).toLocaleDateString("en-us", { day: "numeric" }),
      ) +
      " day of " +
      new Date(date).toLocaleDateString("en-us", { month: "long" }) +
      ", " +
      new Date(date).toLocaleDateString("en-us", { year: "numeric" })
    ).toUpperCase();

  const curDate = new Date();
  const dateStr = (
    curDate.toLocaleDateString("en-us", { weekday: "long" }) +
    ", " +
    dateSuffix(curDate.toLocaleDateString("en-us", { day: "numeric" })) +
    " day of " +
    curDate.toLocaleDateString("en-us", { month: "long" }) +
    ", " +
    curDate.toLocaleDateString("en-us", { year: "numeric" })
  ).toUpperCase();

  const alphabetArray = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const alphabetForSisterCase = "abcdefghijklmnopqrstuvwxyz".split("");

  const todaysDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(currentDate.getDate()).padStart(2, "0");

    const formatDate = `${year}-${month}-${day}`;

    console.log("new", formatDate);
    return formatDate;
  };


  const handleFetchData = async () => {
    setLoading(true);
    await endpoint
      .get(`/case-diary/disposal-cause-list/${date}`)
      .then(({ data }) => {
        // console.log("response with supplied data", data.data);
        let causeArr = data.data;

        const groupedByLocation = causeArr.reduce((result, obj) => {
          const location = obj.location || "N/A"; // fallback if location is missing

          if (!result[location]) {
            result[location] = {};
          }

          const key =
            obj.CaseType.case_type +
            " " +
            obj.CaseTypeCategory.case_type_cat +
            " " +
            (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : "");

          if (!result[location][key]) {
            result[location][key] = [];
          }

          result[location][key].push(obj);

          return result;
        }, []);
        console.log("groupedByLocation", groupedByLocation);
        setDailyCauseList(groupedByLocation);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  //function that adds "judgement" to heading
  const splitHeading = (str) => {
    const firstSpaceIndex = str.indexOf(" ");
    const firstPart = str.slice(0, firstSpaceIndex);
    return (firstPart + " " + "Judgment").toUpperCase();
  };

  //function that removes the adjournment id from heading
  const removeNumber = (str) => {
    const result = str.replace(/[0-9]/g, "");
    return (result + " " + "(s)").toUpperCase();
  };

  const handlePrint = () => {
    const originalBg = document.body.style.backgroundColor;

    document.body.style.backgroundColor = "#fff";

    window.print();

    document.body.style.backgroundColor = originalBg;
  };

  return (
    <>

      {isLoading && (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <img
            src={"/loading.gif"}
            alt={""}
            className="img-fluid"
            style={{ maxWidth: "50px" }}
          />
        </div>
      )}
      {!isLoading && (
        <div id="divToPrint" className="cause-list-page">
          <div className="row mt-4" id="hideDate">
            <div className="col-lg-12 col-md-12 mx-auto">
              <div
                className="card border-0 shadow-sm"
                style={{
                  borderRadius: "16px",
                }}
              >
                <div className="card-body p-4">
                  {/* Title */}
                  <div className="text-center mb-4">
                    <h3
                      style={{
                        fontWeight: "700",
                        color: "#1e293b",
                        marginBottom: "8px",
                      }}
                    >
                      CAUSE LIST
                    </h3>

                    <p
                      className="mb-0"
                      style={{
                        color: "#64748b",
                        fontSize: "14px",
                      }}
                    >
                      Select a hearing date and generate the cause list.
                    </p>
                  </div>

                  {/* Alert */}
                  <div
                    className="mb-4"
                    style={{
                      background: "#fff7ed",
                      border: "1px solid #fed7aa",
                      borderRadius: "10px",
                      padding: "12px 15px",
                    }}
                  >
                    <small
                      style={{
                        color: "#c2410c",
                        fontWeight: "500",
                      }}
                    >
                      <i className="mdi mdi-information-outline mr-1"></i>
                      Please select a date and click Search to generate the cause list.
                    </small>
                  </div>

                  {/* Search Section */}
                  <div className="row align-items-end">
                    <div className="col-md-8">
                      <label
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#475569",
                          marginBottom: "8px",
                        }}
                      >
                        Hearing Date
                      </label>

                      <input
                        type="date"
                        className="form-control"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        style={{
                          height: "48px",
                          borderRadius: "10px",
                          border: "1px solid #dbe3ea",
                        }}
                      />
                    </div>

                    <div className="col-md-4 mt-3 mt-md-0">
                      <button
                        className="btn btn-primary btn-block"
                        type="button"
                        onClick={handleFetchData}
                        style={{
                          height: "48px",
                          borderRadius: "10px",
                          fontWeight: "600",
                        }}
                      >
                        <i className="mdi mdi-magnify mr-1"></i>
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />
          <div
            className="card border-0 shadow-sm"
            style={{
            }}
          >
            <div className="card-body p-4"></div>
            {isLoading && <Loader />}

            {!isLoading && (
              <div className="row mt-4">
                <div className="col-md-12">
                  {Object.entries(dailyCauseList).map(
                    ([location, groupings], locationIndex) => {
                      let firstPanel = "";

                      for (const [_, cases] of Object.entries(groupings)) {
                        for (const caseItem of cases) {
                          if (
                            caseItem.justiceAssignment &&
                            caseItem.justiceAssignment.length > 0
                          ) {
                            firstPanel =
                              caseItem.justiceAssignment[0].panel || "";
                            break;
                          }
                        }
                        if (firstPanel) break;
                      }
                      return (
                        <div key={locationIndex}>
                          <div
                            className="text-center mb-4"
                            style={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              textDecoration: "underline",
                            }}
                          >
                            IN THE SUPREME COURT OF NIGERIA
                            <br /> HOLDEN AT ABUJA <br /> <br />
                            {/* CAUSE LIST FOR{" "} */}

                            {/* {date ? formattedDate : dateStr.toUpperCase()} */}
                            {date ? formatLegalDate(date) : formatLegalDate(new Date())}
                            <br /> <br />

                            DISPOSAL OF APPEALS UNDER ORDER 16 RULE 9 (1) OF THE SUPREME COURT <br /> RULE (2024) AS AMENDED {" "}
                          </div>

                          {Object.entries(dailyCauseList).length > 0 && (
                            <div className="col-md-12 hideBtn">
                              <button
                                className="btn btn-outline-primary w-100"
                                type="button"
                                // onClick={() => window.print()}
                                onClick={handlePrint}
                                id="button-addon2"
                              >
                                Print
                              </button>
                            </div>
                          )}

                          {Object.entries(groupings)
                            .sort(([keyA], [keyB]) => {
                              const isMotionA = keyA
                                .toLowerCase()
                                .includes("motion");
                              const isMotionB = keyB
                                .toLowerCase()
                                .includes("motion");

                              if (isMotionA && !isMotionB) return -1; // Motion first
                              if (!isMotionA && isMotionB) return 1; // Appeal after Motion

                              return keyA.localeCompare(keyB); // alphabetical fallback
                            })
                            .map(([headings, items], index) => (
                              <div className="causeListHeading" key={index}>
                                <div
                                  className="text-center mb-3"
                                  style={{
                                    color: headings.toUpperCase().includes("CIVIL")
                                      ? "#198754"
                                      : headings.toUpperCase().includes("CRIMINAL")
                                        ? "#dc3545"
                                        : headings.toUpperCase().includes("POLITICAL")
                                          ? "#0d6efd"
                                          : "#212529",
                                    fontWeight: "700",
                                    fontSize: "16px",
                                    letterSpacing: "0.3px",
                                    padding: "8px",
                                    background: "#f8f9fa",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {headings.includes(2)
                                    ? `${alphabetArray[index]}. ${splitHeading(headings)}`
                                    : `${alphabetArray[index]}. ${removeNumber(headings)}`}
                                </div>

                                <div className="table-reponsive m-4">
                                  <table
                                    className="table mb-5"
                                    style={{ width: `100%` }}
                                  >
                                    <thead
                                      style={{
                                        backgroundColor: "#f8f9fa",
                                      }}
                                    >
                                      <tr style={{ border: `1px solid black` }}>
                                        <th
                                          style={{
                                            maxWidth: `5px`,
                                            border: `1px solid black`,
                                          }}
                                        >
                                          SN.
                                        </th>
                                        <th
                                          scope="col"
                                          style={{ border: `1px solid black` }}
                                        >
                                          SCN NO.
                                        </th>
                                        {headings
                                          .toUpperCase()
                                          .includes("APPEAL") ? (
                                          <>
                                            <th
                                              scope="col"
                                              style={{
                                                border: `1px solid black`,
                                              }}
                                            >
                                              PARTIES
                                            </th>
                                          </>
                                        ) : (
                                          <>
                                            <th
                                              scope="col"
                                              style={{
                                                border: `1px solid black`,
                                              }}
                                            >
                                              PARTIES
                                            </th>
                                          </>
                                        )}
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {items.map((item, index) => (
                                        <React.Fragment key={index}>
                                          {item.CaseAttachements &&
                                            item.CaseAttachements.map((Case, index2) => {
                                              const hasSisters = item.CaseAttachements.length > 1;

                                              return (
                                                <tr
                                                  key={`${index}-${index2}`}
                                                  style={{
                                                    border: "1px solid black",
                                                  }}
                                                >
                                                  {index2 === 0 && (
                                                    <td
                                                      rowSpan={item.CaseAttachements.length}
                                                      style={{
                                                        border: "1px solid black",
                                                      }}
                                                    >
                                                      {index + 1}.
                                                    </td>
                                                  )}

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      color: item.CaseType.case_color,
                                                    }}
                                                  >
                                                    <strong>
                                                      {hasSisters
                                                        ? `${alphabetForSisterCase[index2]}. ${Case.suite_no}`
                                                        : Case.suite_no}
                                                    </strong>
                                                  </td>

                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      whiteSpace: "normal",
                                                      border: "1px solid black",
                                                    }}
                                                  >
                                                    {/* Appellant / Applicant */}
                                                    <div>
                                                      {Case.appellants}

                                                      {Case.otherAppellantCount === 1 && (
                                                        <>
                                                          {" "}
                                                          <strong>& Anor</strong>
                                                        </>
                                                      )}

                                                      {Case.otherAppellantCount > 1 && (
                                                        <>
                                                          {" "}
                                                          & <strong>{Case.otherAppellantCount} Ors</strong>
                                                        </>
                                                      )}

                                                      {Case.appellants_title && (
                                                        <>
                                                          <br />
                                                          <strong>{Case.appellants_title}</strong>
                                                        </>
                                                      )}
                                                    </div>

                                                    {/* VS */}
                                                    <div
                                                      className="mt-2 mb-2"
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      VS.
                                                    </div>

                                                    {/* Respondent */}
                                                    <div>
                                                      {Case.respondent}

                                                      {Case.otherRespondentCount === 1 && (
                                                        <>
                                                          {" "}
                                                          <strong>& Anor</strong>
                                                        </>
                                                      )}

                                                      {Case.otherRespondentCount > 1 && (
                                                        <>
                                                          {" "}
                                                          & <strong>{Case.otherRespondentCount} Ors</strong>
                                                        </>
                                                      )}

                                                      {Case.respondent_title && (
                                                        <>
                                                          <br />
                                                          <strong>{Case.respondent_title}</strong>
                                                        </>
                                                      )}
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </React.Fragment>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            ))}
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            )}

            {Object.entries(dailyCauseList).length > 0 && (
              <div className="col-md-12 hideBtn mb-3">
                <button
                  className="btn btn-outline-primary w-100"
                  type="button"
                  // onClick={() => window.print()}
                  onClick={handlePrint}
                  id="button-addon2"
                >
                  Print
                </button>
              </div>
            )}

            {/* <br /> */}
          </div >
        </div >
      )}
    </>
  );
};

export default DisposalCauseList;
